// @ts-expect-error incompatibility with node16 resolution
import {Dialog, Transition} from '@headlessui/react';
import {Fragment, useState} from 'react';
import clsx from 'clsx';
import {Link} from '@shopify/hydrogen';
import {
  SanityNavigationDropdown,
  SanityNavigationDropdownColumns,
} from '../../types';
import getLocale from '../../hooks/getLocale';

type Props = {
  dropdown: SanityNavigationDropdown;
  bannerIsVisible?: boolean;
};

export default function NavigationDropdown({dropdown, bannerIsVisible}: Props) {
  const [isOpen, setIsOpen] = useState(false);

  const handleClose = () => {
    setIsOpen(false);
    document?.body.classList.remove('dropdown-open');
  };
  const handleOpen = () => {
    setIsOpen(true);
    document?.body.classList.add('dropdown-open');
  };

  return (
    <div className="relative flex items-center">
      {/* Title */}
      <>
        <button
          className={clsx('linkTextNavigation', isOpen ? 'active' : '')}
          onClick={handleOpen}
        >
          <div className="inline-flex items-center font-industry text-sm font-medium uppercase">
            {dropdown?.title && typeof dropdown.title === 'object'
              ? getLocale(dropdown.title)
              : dropdown?.title}
          </div>
        </button>
      </>
      <Transition show={isOpen}>
        <Dialog
          open={isOpen}
          className="relative z-10"
          onClose={handleClose}
          static
        >
          {/* Overlay */}
          <Transition.Child
            as={Fragment}
            enter="ease-out duration-500"
            enterFrom="opacity-0"
            enterTo="opacity-100"
            leave="ease-in duration-500"
            leaveFrom="opacity-100"
            leaveTo="opacity-0"
          >
            <div
              aria-hidden="true"
              className="pointer-events-none fixed inset-0 bg-black bg-opacity-20"
            />
          </Transition.Child>

          <Transition.Child
            as={Fragment}
            enter="ease-in-out duration-500"
            enterFrom="-translate-y-full"
            enterTo="translate-y-0"
            leave="ease-in-out duration-500"
            leaveFrom="translate-y-0"
            leaveTo="-translate-y-full"
          >
            <Dialog.Panel
              className={clsx(
                'fixed left-0 right-0 top-[70px] w-screen text-black',
                bannerIsVisible && 'mt-[40px]',
              )}
            >
              <div className={'bg-menu px-4 py-8 md:px-8'}>
                <div
                  className={clsx(
                    'container w-full max-w-[70rem] px-4 xl:gap-12',
                  )}
                >
                  <div className="grid grid-cols-3 gap-6">
                    {dropdown.columns?.map(
                      (column: SanityNavigationDropdownColumns, index) => (
                        <div
                          className={
                            // @ts-ignore
                            index + 1 !== dropdown?.columns.length
                              ? 'border-r border-black'
                              : ''
                          }
                          key={column._key}
                        >
                          <ul className={'text-xs'}>
                            {column?.links?.map((link) => {
                              return (
                                link?.url && (
                                  <li className={'truncate'} key={link._key}>
                                    <Link
                                      to={link.url}
                                      className={clsx(
                                        'hover:underline',
                                        // @ts-ignore
                                        link.header ? 'font-bold' : '',
                                      )}
                                      onClick={handleClose}
                                    >
                                      {link.linkTitle &&
                                      typeof link.linkTitle === 'object'
                                        ? getLocale(link.linkTitle)
                                        : link?.title ?? ''}
                                    </Link>
                                  </li>
                                )
                              );
                            })}
                          </ul>
                        </div>
                      ),
                    )}
                  </div>
                </div>
              </div>
            </Dialog.Panel>
          </Transition.Child>
        </Dialog>
      </Transition>
    </div>
  );
}
